import { useComputationActions } from '../../../../../../hooks/actions/user-computation-actions';
import { useProposalComputation } from '../../../../../../hooks/proposal/use-proposal-computation';

interface Props {
    isLoading: boolean;
}

// export default function RatesActions({ isLoading: isLoadingComputeRates }: Props) {
export default function RatesActions() {

    const { isUpdateRates, ratesActiveTab } = useProposalComputation()
    const { 
        cantEdit, 
        handleCancelUpdateRates, 
        handleSaveRates, 
        handleIsUpdateRates, 
        handleDownloadRatesTemplate, 
        fileInputRef, 
        handleIsUploadRates, 
        handleUploadFileRates, 
        selectedRatesFile, 
        isUploadingRates, 
        handleSelectRatesFile,
        isLoadingComputeRates,
    } = useComputationActions();
    const labelSaveRate = isLoadingComputeRates ? 'Saving' : 'Save';
    if (ratesActiveTab !== "rates") return null;
    const baseButtonClass = "inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50";
    const primaryButtonClass = `${baseButtonClass} border border-[#186cb2] bg-[#186cb2] text-white hover:bg-[#155b96]`;
    const secondaryButtonClass = `${baseButtonClass} border border-gray-300 bg-white text-gray-700 hover:bg-gray-50`;
    const outlineButtonClass = `${baseButtonClass} border border-[#186cb2]/40 bg-white text-[#186cb2] hover:bg-[#186cb2]/5`;
    
    return (
        <>
            <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex w-full min-w-0 sm:w-auto">
                    <button type="button" disabled={isUpdateRates} onClick={handleDownloadRatesTemplate} className={`${primaryButtonClass} w-full sm:w-auto`}>
                        <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5 shrink-0" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v12m0 0 4-4m-4 4-4-4M5 21h14a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2" />
                        </svg>
                        <span className="whitespace-nowrap">Export Template</span>
                    </button>
                </div>
                <div className="flex w-full min-w-0 justify-end">
                    {isUpdateRates ? (
                        <div className="flex w-full gap-2 sm:w-auto">
                            <button type="button" disabled={isLoadingComputeRates || cantEdit} onClick={handleCancelUpdateRates} className={`${secondaryButtonClass} flex-1 sm:flex-none`}>
                                <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5 shrink-0" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6L6 18" />
                                </svg>
                                <span className="whitespace-nowrap">Cancel</span>
                            </button>
                            <button type="button" disabled={cantEdit || isLoadingComputeRates} onClick={handleSaveRates} className={`${primaryButtonClass} flex-1 sm:flex-none`}>
                                <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5 shrink-0" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12.5l4.5 4.5L19 7.5" />
                                </svg>
                                <span className="whitespace-nowrap">{labelSaveRate}</span>
                            </button>
                        </div>
                    ) : selectedRatesFile ? (
                        <div className="flex w-full min-w-0 items-center gap-2 sm:w-auto">
                            <span title={selectedRatesFile.name} className="min-w-0 flex-1 truncate text-xs text-gray-600 sm:max-w-[200px]">
                                {selectedRatesFile.name}
                            </span>
                            <button type="button" disabled={isUploadingRates || cantEdit} onClick={handleCancelUpdateRates} className={secondaryButtonClass}>
                                <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5 shrink-0" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6L6 18" />
                                </svg>
                                <span className="whitespace-nowrap">Cancel</span>
                            </button>
                            <button type="button" disabled={isUploadingRates || cantEdit} onClick={handleUploadFileRates} className={primaryButtonClass}>
                                <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5 shrink-0" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21V9m0 0l-4 4m4-4 4 4M5 3h14a2 2 0 0 1 2 2v3M3 8V5a2 2 0 0 1 2-2" />
                                </svg>
                                <span className="whitespace-nowrap">{isUploadingRates ? 'Uploading...' : 'Save Upload'}</span>
                            </button>
                        </div>
                    ) : (
                        <div className="flex w-full gap-2 sm:w-auto">
                            <button type="button" disabled={cantEdit || isUploadingRates} onClick={handleIsUpdateRates} className={`${outlineButtonClass} flex-1 sm:flex-none`}>
                                <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5 shrink-0" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 20h9" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 3.5a2.121 2.121 0 0 1 3 3L8 18l-4 1 1-4L16.5 3.5z" />
                                </svg>
                                <span className="whitespace-nowrap">Edit Rates</span>
                            </button>
                            <button type="button" disabled={cantEdit || isUploadingRates} onClick={handleIsUploadRates} className={`${outlineButtonClass} flex-1 sm:flex-none`}>
                                <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5 shrink-0" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 16V4" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 8l4-4 4 4" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 20h14a2 2 0 0 0 2-2v-3M3 15v3a2 2 0 0 0 2 2" />
                                </svg>
                                <span className="whitespace-nowrap">Upload Rates</span>
                            </button>
                            <input ref={fileInputRef} type="file" accept=".xlsx,.xls,.csv" hidden onChange={handleSelectRatesFile} />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}